import type { EditorProps } from '@monaco-editor/react';
import { useMemo } from 'react';

const baseOptions: EditorProps['options'] = {
  minimap: {
    enabled: false,
  },
  scrollbar: {
    verticalScrollbarSize: 5,
    horizontalScrollbarSize: 5,
    verticalSliderSize: 5,
  },
  lineNumbersMinChars: 2,
  folding: true,
  showFoldingControls: 'always',
  renderLineHighlight: 'none',
  padding: {
    top: 10,
    bottom: 5,
  },
  fixedOverflowWidgets: true,
  readOnly: false,
};

const useOptions = (config = {}) => {
  return useMemo(() => ({ ...baseOptions, ...config }), [config]);
};

export default useOptions;
